import { SignalOptions, createSignal } from 'solid-js'

const triggerOptions: SignalOptions<false> = { equals: false }

export type TriggerSignal = [track: () => false, dirty: () => void]
export function createTriggerSignal(): TriggerSignal {
  // eslint-disable-next-line solid/reactivity
  return createSignal<false>(0 as unknown as false, triggerOptions) as TriggerSignal
}
